import { apiFetch } from './client.js';
import type { ChildDraft } from './use-people.js';

/**
 * Finishes an athlete a coach added - name, date of birth, waiver, photo and
 * video - or signs the waiver in force for one already finished (stage C).
 * The body is Add a child's; ApiError carries a refusal's code and field.
 */
export function finishChild(
  getToken: () => Promise<string | null>,
  clientId: string,
  draft: ChildDraft,
): Promise<{ finished: boolean }> {
  return apiFetch(`/api/people/${encodeURIComponent(clientId)}/details`, getToken, {
    method: 'PUT',
    body: JSON.stringify(draft),
  });
}
